module.exports = __webpack_public_path__ + "img/klaus-a3.a8739959.svg";